<script setup lang="ts">
import 'bootstrap-3-typeahead';

import $ from 'jquery';
import type { Ref } from 'vue';
import {
    computed,
    shallowRef,
    unref,
} from 'vue';

import InputControl from './input-control.vue';
import ToolTip from './tool-tip.vue';

const props = defineProps<{
    tooltip?: 'iva' | 'iban' | string;
}>();

const inputRef = shallowRef<{ input: Ref<HTMLInputElement | undefined> } | undefined>();
const input = computed(() => unref(unref(inputRef)?.input));
const eyeRef = shallowRef<HTMLElement | undefined>();
const toolTipTemplate = '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner tooltip-format"></div></div>';

function ivaToolTip() {
    const ctl = $(unref(input) ?? []);
    let value = String(ctl.val());
    value = value.replace(/\s+/g, '').toUpperCase();
    const res = /^(\d{4})(\d{0,4})(\d{0,3})(.*)$/.exec(value);
    if(res) {
        let index = 1;
        value = '';
        while(res[index]) {
            if(value) value += ' ';
            value += res[index];
            index++;
        }
    }
    return value;
}

function ibanToolTip() {
    const ctl = $(unref(input) ?? []);
    let value = String(ctl.val());
    value = value.replace(/\s+/g, '').toUpperCase();
    const res = /^(.{0,2})(.{0,2})(.{0,3})(.{0,4})(.{0,4})(.{0,4})(.{0,4})(.*)$/.exec(value);
    if(res) {
        let index = 1;
        value = '';
        while(res[index]) {
            if(value) value += ' ';
            value += res[index];
            index++;
        }
    }
    return value;
}

function toolTipTitle() {
    let title: string | ((this: Element) => string) = '';
    switch(props.tooltip) {
        case 'iva':
            title = ivaToolTip;
            break;
        case 'iban':
            title = ibanToolTip;
            break;
        default:
            title = props.tooltip ?? '';
            break;
    }

    return title;
}
</script>
<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>
<template>
    <div class="input-group">
        <InputControl v-bind="$attrs" ref="inputRef" />
        <ToolTip
            v-slot="{tooltipprops}"
            :element="eyeRef"
            :template="toolTipTemplate"
            container="body"
            placement="auto top"
            :title="toolTipTitle"
        >
            <span
                v-bind="tooltipprops"
                ref="eyeRef"
                class="input-group-addon"
                style="cursor: default;"
            >
                <span class="bi bi-eye" />
            </span>
        </ToolTip>
    </div>
</template>
